// extracted by mini-css-extract-plugin
module.exports = {"section":"Partners_section__2L2De","client":"Partners_client__1SBTs"};